import moment from "moment";
import React, { Fragment, useState } from "react";

const palette = [
  { bg: "rgba(220, 252, 231, 0.6)", border: "#22c55e" }, // Soft green
  { bg: "rgba(219, 234, 254, 0.6)", border: "#3b82f6" }, // Soft blue
  { bg: "rgba(243, 232, 255, 0.6)", border: "#a855f7" }, // Soft purple
  { bg: "rgba(254, 243, 199, 0.6)", border: "#f59e0b" }, // Soft amber
  { bg: "rgba(252, 228, 236, 0.6)", border: "#ec4899" }, // Soft pink
  { bg: "rgba(224, 242, 254, 0.6)", border: "#0ea5e9" }, // Soft sky blue
  { bg: "rgba(204, 251, 241, 0.6)", border: "#14b8a6" }, // Soft teal
  { bg: "rgba(245, 245, 244, 0.6)", border: "#78716c" }, // Soft stone
  { bg: "rgba(254, 226, 226, 0.6)", border: "#ef4444" }, // Soft red
  { bg: "rgba(255, 237, 213, 0.6)", border: "#f97316" }, // Soft orange
  { bg: "rgba(236, 253, 245, 0.6)", border: "#10b981" }, // Mint
  { bg: "rgba(254, 249, 195, 0.6)", border: "#eab308" }, // Soft yellow
  { bg: "rgba(230, 230, 250, 0.6)", border: "#8b5cf6" }, // Lavender
  { bg: "rgba(224, 231, 255, 0.6)", border: "#6366f1" }, // Indigo
  { bg: "rgba(236, 254, 255, 0.6)", border: "#06b6d4" }  // Cyan
];

export const getServiceColorAndBorder = (serviceName, servicesList = []) => {
  if (!serviceName) return { bg: "transparent", border: "transparent" };
  
  const index = servicesList.indexOf(serviceName);
  if (index !== -1) {
    return palette[index % palette.length];
  }
  
  // Fallback: stable hash-based pastel color
  let hash = 0;
  for (let i = 0; i < serviceName.length; i++) {
    hash = serviceName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return {
    bg: `hsl(${hue}, 75%, 95%)`,
    border: `hsl(${hue}, 70%, 45%)`
  };
};

const LogRecord = ({ log, services = [] }) => {
  console.log(log, "check the logs here...");

  const [isError, setIsError] = useState(
    log["_source"]?.hasOwnProperty("error")
  );

  const serviceName = log?._source?.fields?.service || "";
  const { bg: bgColor, border: borderColor } = getServiceColorAndBorder(serviceName, services);

  const containerStyle = {
    width: "max-content",
    minWidth: "100%",
    backgroundColor: bgColor,
    borderLeft: `4px solid ${borderColor}`,
    padding: "6px 12px 6px 12px",
    margin: "2px 0",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column"
  };

  return (
    <Fragment>
      {log?._source?.log_level?.toUpperCase() === "ERROR" ||
        log?._source?.log_level?.toUpperCase() === "CRITICAL" ? (
        <div style={containerStyle}>
          <pre
            style={{
              fontSize: 11,
              margin: "unset",
              color: "red",
              fontWeight: "bold",
            }}
          >
            {moment(log?._source?.["@timestamp"])
              .tz("Australia/Sydney")
              .format("DD-MM-YYYY HH:mm:ss.SSS")}{" "}
            |{log?._source?.fields?.service || "N/A"} |
            {log?._source?.log_level?.toUpperCase() || "N/A"} |
            {log?._source?.message || "N/A"} |
            {log?._source?.log?.origin?.file?.name || "N/A"}:
            {log?._source?.log?.origin?.file?.line || "N/A"} |
            {log?._source?.thread_name || "N/A"}
          </pre>

          {isError && (
            <div>
              <pre style={{ fontSize: 11, margin: "unset" }}>
                Stacktrace: <br />
                {log?._source?.error?.stack_trace || "N/A"}
                <br />
                Type: {log?._source?.error?.type || "N/A"}
                <br />
                Message: {log?._source?.error?.message || "N/A"}
              </pre>
              {"-------------------------------------------------"}
            </div>
          )}
        </div>
      ) : log?._source?.log_level?.toUpperCase() === "WARNING" ? (
        <div style={containerStyle}>
          <pre
            style={{
              fontSize: 11,
              margin: "unset",
              color: "blue",
              fontWeight: "bold",
            }}
          >
            {moment(log?._source?.["@timestamp"])
              .tz("Australia/Sydney")
              .format("DD-MM-YYYY HH:mm:ss.SSS")}{" "}
            |{log?._source?.fields?.service || "N/A"} |
            {log?._source?.log_level?.toUpperCase() || "N/A"} |
            {log?._source?.message || "N/A"} |
            {log?._source?.log?.origin?.file?.name || "N/A"}:
            {log?._source?.log?.origin?.file?.line || "N/A"} |
            {log?._source?.thread_name || "N/A"}
          </pre>
        </div>
      ) : (
        <div style={containerStyle}>
          <pre style={{ fontSize: 11, margin: "unset" }}>
            {moment(log?._source?.["@timestamp"])
              .tz("Australia/Sydney")
              .format("DD-MM-YYYY HH:mm:ss.SSS")}{" "}
            |{log?._source?.fields?.service || "N/A"} |
            {log?._source?.log_level?.toUpperCase() || "N/A"} |
            {log?._source?.message || "N/A"} |
            {log?._source?.log?.origin?.file?.name || "N/A"}:
            {log?._source?.log?.origin?.file?.line || "N/A"} |
            {log?._source?.thread_name || "N/A"}
          </pre>
        </div>
      )}
    </Fragment>
  );
};

export default LogRecord;
